import { useEffect } from "react";
import {
  Autocomplete,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Grid } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setCommissionPlansSearchQuery } from "../../../features/dealsPromotionsSlice";
import CommissionPlansFilterPanel from "./CommissionPlansFilterPanel";

const DealsAndPromotionsFilter = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const isLoading = useSelector(
    (state: any) => state.dealsPromotions.isLoadingDealsPortfolioPlans,
  );
  const searchQuery = useSelector(
    (state: any) => state.dealsPromotions.commissionPlans.searchQuery,
  );
  const dealsPortfolioPlans = useSelector(
    (state: any) => state.dealsPromotions.dealsPortfolioPlans,
  );

  // Hydrate Redux from URL on mount
  useEffect(() => {
    const urlSearch = searchParams.get("search") ?? "";
    if (urlSearch !== searchQuery) {
      dispatch(setCommissionPlansSearchQuery(urlSearch));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const brandOptions = dealsPortfolioPlans
    ? Array.from(
        new Map(
          dealsPortfolioPlans.map((item: any) => [
            item.brand_id,
            { label: item.brand_name, id: item.brand_id },
          ]),
        ).values(),
      )
    : [];

  const selectedOption =
    brandOptions.find((o: any) => o.label === searchQuery) ?? null;

  const handleSearchChange = (_: any, newValue: any) => {
    const query = newValue?.label ?? "";
    dispatch(setCommissionPlansSearchQuery(query));
    setSearchParams(
      (prev) => {
        if (query) {
          prev.set("search", query);
        } else {
          prev.delete("search");
        }
        prev.set("page", "0");
        return prev;
      },
      { replace: true },
    );
  };

  return (
    <Box py={1} px={2}>
      <Typography>
        View and edit commission deal plans per brand &nbsp;·&nbsp;{" "}
        {dealsPortfolioPlans
          ? `${dealsPortfolioPlans.length} plans across ${
              new Set(dealsPortfolioPlans.map((i: any) => i.brand_id)).size
            } brands`
          : ""}
      </Typography>

      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid size={3}>
          <Autocomplete
            data-tracker="791"
            sx={{ width: "100%", py: 2 }}
            options={brandOptions}
            value={selectedOption}
            onChange={handleSearchChange}
            disabled={isLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search Brand or choose from the list"
                label="Brand Name"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ marginLeft: "12px" }} />
                      </InputAdornment>
                    ),
                  },
                }}
                color="secondary"
              />
            )}
            size="small"
          />
        </Grid>
        <Grid size={9}>
          <CommissionPlansFilterPanel />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DealsAndPromotionsFilter;
